// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import user01Icon from "@/assets/icons/user-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type User01IconProps = Omit<IconProps, "name">;

export function User01Icon(props: User01IconProps): React.ReactNode {
  return <Icon name={user01Icon} {...props} />;
}
